import { BreakpointObserver } from '@angular/cdk/layout';
import { StepperOrientation } from '@angular/cdk/stepper';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TripService } from 'app/services/trip.service';
import { WaybillService } from 'app/services/waybill.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

declare var $: any;

export interface UserData {
  id: string;
  name: string;
  progress: string;
  color: string;
}

/** Constants used to fill up our data base. */
const COLORS = ['maroon', 'red', 'orange', 'yellow', 'olive', 'green', 'purple',
  'fuchsia', 'lime', 'teal', 'aqua', 'blue', 'navy', 'black', 'gray'];
const NAMES = ['Maia', 'Asher', 'Olivia', 'Atticus', 'Amelia', 'Jack',
  'Charlotte', 'Theodore', 'Isla', 'Oliver', 'Isabella', 'Jasper',
  'Cora', 'Levi', 'Violet', 'Arthur', 'Mia', 'Thomas', 'Elizabeth'];

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

  displayedWayBills = ['index', 'waybill_date', 'waybill_no', 'sender_name', 'receiver_name', 'item_name', 'quantity', 'loaded_pkg', 'trip_name', 'check_point', 'tracking_position_status', 'narration', 'action'];
  displayedColumns = ['id', 'name', 'progress', 'color'];
  dataSource: MatTableDataSource<UserData>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  detailed: any;
  not_detailed: any[];
  datasource: MatTableDataSource<any>;
  loaded_total: any;
  quantity_total: any;
  show_full: any;
  datasource1: MatTableDataSource<any>;

  constructor(private formbuilder: FormBuilder, private waybillService: WaybillService) {
    // this.datasource1 = new MatTableDataSource([]);
  }

  /**
* Set the paginator and sort after the view init since this component will
* be able to query its view for the initialized paginator and sort.
*/
  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  ngOnInit(): void {``
    this.onSubmitDate();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  onSubmitDate() {
    console.log();
    
    // Create 100 users
    // const users: UserData[] = [];
    // for (let i = 1; i <= 100; i++) { users.push(this.createNewUser(i)); }

    // // Assign the data to the data source for the table to render
    // this.dataSource = new MatTableDataSource(users);

    // this.searchValue = [];
    // this.searchNameValue = [];
    // if (this.from == null || this.to == null) {
    //   this.toastr.info('Select valid date');
    //   return;
    // }
    // const from = this.datePipe.transform(this.from, 'yyyy-MM-dd');
    // const to = this.datePipe.transform(this.to, 'yyyy-MM-dd');
    // console.log(from);
    // console.log(to);
    // if (new Date(from) > new Date(to)) {
    //   this.toastr.info('Select valid date');
    //   return;
    // }
    this.waybillService.getWayBillsBetween("2021-09-03", "2021-09-13").subscribe((res: any) => {
      console.log(res);
      this.showCreation(res.data);
    });
  }

  showCreation(details) {
    let waybills = new Array;
    let id = 0;
    let o_id = 0;
    let item_name = '';
    let quantity = 0;
    let loaded_pkg = 0;
    let consignment_id = 0;
    let o_consignment_id = 0;

    details.forEach(element => {
      id = element.id;
      consignment_id = element.consignment_id;

      if (id != o_id) {
        waybills.push(element)
        o_id = element.id;
        o_consignment_id = element.consignment_id;

        item_name = element.item_name
        quantity = element.quantity
        loaded_pkg = element.loaded_pkg
      } else {
        item_name += ', ' + element.item_name;
        loaded_pkg += element.loaded_pkg;

        if (consignment_id != o_consignment_id) {
          quantity += element.quantity;
          o_consignment_id = element.consignment_id;
        } else {
          quantity = element.quantity;
        }

        let new_value = { 'id': id, 'waybill_date': element.waybill_date, 'waybill_no': element.waybill_no, 'sender_name': element.sender_name, 'receiver_code': element.receiver_code, 'receiver_name': element.receiver_name, 'item_name': item_name, 'quantity': quantity, 'loaded_pkg': loaded_pkg, 'trip_name': element.trip_name, 'check_point': element.check_point, 'tracking_position_status': element.tracking_position_status, 'narration': element.narration }

        waybills[waybills.length - 1] = new_value;
      }
    });

    this.detailed = details;
    this.not_detailed = waybills;

    this.datasource = new MatTableDataSource(waybills);
    this.loaded_total = this.datasource.data.map(t => Number(t.loaded_pkg)).reduce((acc, value) => acc + value, 0);
    this.quantity_total = this.datasource.data.map(t => Number(t.quantity)).reduce((acc, value) => acc + value, 0);

    console.log(this.loaded_total);
    console.log(this.quantity_total);

    let data = [];
    if (this.show_full) {
      data = this.detailed
    } else {
      data = this.not_detailed
    }

    this.datasource = new MatTableDataSource(data);
    // this.datasource.sort = this.sort;
  }

  /** Builds and returns a new User. */
  // createNewUser(id: number): UserData {
  //   const name =
  //     NAMES[Math.round(Math.random() * (NAMES.length - 1))] + ' ' +
  //     NAMES[Math.round(Math.random() * (NAMES.length - 1))].charAt(0) + '.';

  //   return {
  //     id: id.toString(),
  //     name: name,
  //     progress: Math.round(Math.random() * 100).toString(),
  //     color: COLORS[Math.round(Math.random() * (COLORS.length - 1))]
  //   };
  // }
}
